import globals from './Globals';
import loader from './Loader';
import RenderContainer from './RenderContainer';

class NextPrevPageButton extends RenderContainer {
  constructor(direction, messageStr) {
    super();
    this.direction = direction;
    this.messageStr = messageStr;
    this.name = this.direction === 'next' ? 'NextButton' : 'PreviousButton';
    this.imageName = this.direction === 'next' ? 'next' : 'previous';
    this.bitmap = null;
    loader.addItem(this, this.imageName);
    this.relX = this.direction === 'next' ? 0.92 : 0.08;
    this.relY = 0.50;
    const pos = globals.relToScreen({ x: this.relX, y: this.relY });
    this.x = pos.x;
    this.y = pos.y;
    this.maxWidth = 0.15;
    this.maxHeight = 0.15;
    const size = globals.relSizeToScreen({
      x: this.maxWidth,
      y: this.maxHeight
    });
    this.render.stream = false;
    this.width = size.x;
    this.height = size.y;
    this.setBounds(this.x, this.y, this.width, this.height);
    this.on('click', this.press, this);
  }

  press() {
    this.dispatchEvent(this.messageStr, true);
  }

  loaded() {
    const image = loader.getItem(this.imageName);
    this.clipImageSizeToSize(image);
    this.centerOnSelf();

    this.bitmap = new createjs.Bitmap(image);
    this.addChild(this.bitmap);
    this.render.once = true;
    this.render.stream = false;
  }
}

export { NextPrevPageButton as default };
